import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import { Alert, Snackbar } from '@mui/material';
import Switch from '@mui/material/Switch';
import i18n from '../../../../../utils/i18n';
import StyledButton from '../../../../../shared/components/styledButton/styledButton';
import ACTIONS from '../../../../../redux/action';
import { useSelector, useDispatch } from 'react-redux';

const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    color: 'grey !important',
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#28B446 !important',
    '&:hover': {
      backgroundColor: alpha('#28B446', theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#28B446',
  },
}));

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function PreferencesInputs3({ storeObj, dataText, submitToDB }) {
  const dispatch = useDispatch();
  const [allChecked, setAllChecked] = React.useState(true);
  const providerPreferences = useSelector((state) => state[storeObj]);
  const [modified, setModified] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  // console.log('DATATEXT', dataText);

  const checkInputValue = (e, item) => {
    let tempObj = providerPreferences.filter((i) => i.id === item.id)[0];
    tempObj.value = parseInt(e.target.value);
    dispatch(
      ACTIONS.updateArrayofObjProviderInfo({
        updatedObj: tempObj,
        arrOfObj: storeObj,
      })
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const inputChangeHandler = (e, item) => {
    setModified(true);
    let tempObj = providerPreferences.filter((i) => i.id === item.id)[0];
    tempObj.value = parseInt(e.target.value);
    dispatch(
      ACTIONS.updateArrayofObjProviderInfo({
        updatedObj: tempObj,
        arrOfObj: storeObj,
      })
    );
  };

  React.useEffect(() => {
    dataText.forEach((item) => {
      if (providerPreferences.filter((e) => e.on === false).length > 0) {
        setAllChecked(false);
        return;
      } else {
        setAllChecked(true);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerPreferences]);

  const handleChange = (event, item) => {
    setModified(true);
    let tempObj = providerPreferences.filter((i) => i.id === item.id)[0];
    tempObj.on = event.target.checked;
    dispatch(
      ACTIONS.updateArrayofObjProviderInfo({
        updatedObj: tempObj,
        arrOfObj: storeObj,
      })
    );
  };

  const checkAll = (event) => {
    setModified(true);
    let status = event.target.checked;
    dataText.forEach((item) => {
      let tempObj = providerPreferences.filter((i) => i.id === item.id)[0];
      tempObj.on = status;
      dispatch(
        ACTIONS.updateArrayofObjProviderInfo({
          updatedObj: tempObj,
          arrOfObj: storeObj,
        })
      );
    });
  };

  const getObject = (id, array) => {
    return array.filter((e) => e.id === id)[0];
  };

  return (
    <div className='ProviderInputContainerCentered'>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        style={{ width: '50%' }}
      >
        <Alert onClose={handleClose} severity='success' className='AlertWidth'>
          {i18n.t('general.savedmessage')}
        </Alert>
      </Snackbar>
      
      <div className='ProviderInputContainer' style={{ padding: '12px 24px' }}>
        {dataText.map((item, i) => {
          let fetchedData = getObject(item.id, providerPreferences);
          return (
            <div className='CenteredInput FullWidth' key={i}>
              <p>{item.label}</p>
              <GreenSwitch
                {...label}
                id={item.id}
                checked={fetchedData.on}
                onChange={(event) => {
                  handleChange(event, item);
                }}
              />
              {fetchedData.on ? (
                <>
                  <span style={{ color: '#28b446' }}>
                    {i18n.t('provider.iwantit')}
                  </span>
                </>
              ) : (
                <span style={{ color: 'grey' }}>
                  {i18n.t('provider.idontwantit')}
                </span>
              )}
              <div className='modifierInput'>
                {fetchedData.on && (
                  <>
                    <input
                      type='number'
                      className='incrInput2'
                      id={fetchedData.id}
                      value={`${fetchedData.value}`}
                      onChange={(e) => {
                        inputChangeHandler(e, item);
                      }}
                      onBlur={(e) => {
                        checkInputValue(e, item);
                      }}
                    />


                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {modified ? (
        <StyledButton
          onClick={() => {
            if (modified) {
              // console.log('PROV PREFS', providerPreferences);
              submitToDB({
                [`${storeObj}`]: providerPreferences,
              });
              setOpen(true);
              setModified(false);
            }
          }}
          color={'Primary'}
        >
          {i18n.t('general.save')}
        </StyledButton>
      ) : null}
    </div>
  );
}
